import React from "react";
import ProjectList from "../components/ProjectList";
import { projectListData } from "../helpers/projectListData";
import { motion } from "framer-motion";
import Profile from "../components/Profile";
import Social from "../components/Social";
import Blog from "../components/Blog";
import { NavLink } from "react-router-dom";
import { gridContainterVariants } from "../utilities/customHooks";

function Home() {
  return (
    <>
      <Profile />
      <motion.div
        className="box right"
        variants={gridContainterVariants}
        initial="hidden"
        animate="show"
      >
        <div className="section">
          <h2>
            🎨 <span>Projects</span>
          </h2>
          <NavLink className="all" to="/projects">
            View All
          </NavLink>
        </div>
        {projectListData.slice(0, 3).map((project, index) => {
          return (
            <ProjectList
              key={index}
              id={index}
              name={project.name}
              content={project.content}
              image={project.image}
              tags={project.tags}
            />
          );
        })}
        <Social />
      </motion.div>
    </>
  );
}

export default Home;
